import { createSlice } from "@reduxjs/toolkit";
import {
  getCategriesService,
  getCategoryByIdService,
} from "../services/categories_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  categoriesList: [],
  metaCategories: null,
  categoryInfo: null,
};

const slice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getCategriesService.fulfilled, (state, action) => {
        console.log(action.payload?.data?.data);
        state.isLoading = false;
        state.categoriesList = action.payload?.data?.data?.data;
        //     state.metaCategories = action.payload.data.meta.meta;
      })
      .addCase(getCategriesService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getCategriesService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getCategoryByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categoryInfo = action.payload?.data?.data;
      })
      .addCase(getCategoryByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getCategoryByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
